import { FC, memo } from 'react';

import { AppLink } from '@/shared/ui/AppLink';
import { useSeo, seoDefaults } from '@/shared/lib/seo/seo';
import { Page } from '@/widgets/Page';

import './NotFoundPage.css';

export const NotFoundPage: FC = memo(() => {
    useSeo({
        title: 'Страница не найдена',
        description: 'Запрошенный адрес не существует или был перемещён.',
        canonicalPath: '/404',
        robots: seoDefaults.robots.noindex,
    });

    return (
        <Page className="NotFoundPage">
            <h1 className="NotFoundPageTitle">404</h1>
            <p className="NotFoundPageDescription">
                Страница не найдена. Вернитесь на главную, чтобы открыть доступные разделы.
            </p>
            <AppLink route="/" className="NotFoundPageLink">
                На главную
            </AppLink>
        </Page>
    );
});
